const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
        },
      },
      dashboard: {
        loggedAs: "Logged in as",
        roleAdmin: "Administrator",
        roleUser: "Agent",
        roleSuper: "Super admin",
        teamBoardTitle: "Team tickets",
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
        },
        messages: {
          inAttendance: {
            title: "In Service"
          },
          waiting: {
            title: "Waiting"
          },
          closed: {
            title: "Closed"
          }
        }
      },
      connections: {
        title: "Connections",
        toasts: {
          deleted: "WhatsApp connection deleted sucessfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
        },
        buttons: {
          add: "Add WhatsApp",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connectiing",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
        testBadge: "TEST",
      },
      emptyState: {
        noResults: {
          title: "Nothing found",
          message: "Try searching with a different term.",
        },
        connections: {
          title: "Connect your WhatsApp",
          message:
            "Connect a WhatsApp number to start receiving messages from your customers.",
          action: "Connect WhatsApp",
        },
        contacts: {
          title: "No contacts yet",
          message:
            "Contacts show up here automatically when customers message you — or add one manually.",
          action: "Add contact",
        },
        queues: {
          title: "Organize your service into queues",
          message:
            "Queues route each customer to the right department, like Sales or Support.",
          action: "Create queue",
        },
        quickAnswers: {
          title: "Create quick replies",
          message:
            "Save shortcuts for the messages you send most and speed up your service.",
          action: "Create quick reply",
        },
        users: {
          title: "Add your team",
          message:
            "Register the agents who will answer your company's customers.",
          action: "Add user",
        },
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          default: "Default",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
      },
      qrCode: {
        message: "Read QrCode to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
        },
        searchPlaceholder: "Search ...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related tickets will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      quickAnswersModal: {
        title: {
          add: "Add Quick Reply",
          edit: "Edit Quick Answer",
        },
        form: {
          shortcut: "Shortcut",
          message: "Quick Reply",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Quick Reply saved successfully.",
      },
      queueModal: {
        title: {
          add: "Add queue",
          edit: "Edit queue",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          whatsapp: "Default Connection",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        toasts: {
          deleted: "The ticket you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search tickets and messages.",
        },
        buttons: {
          showAll: "Whole team",
          showAllTooltip:
            "On: shows tickets from every agent. Off: shows only yours.",
        },
      },
      testMode: {
        title: "Test Mode",
        config: {
          title: "Test setup",
          subtitle:
            "Simulate a customer conversation without using a real WhatsApp.",
        },
        connection: {
          label: "Test connection",
          createButton: "Create test connection",
          emptyTitle: "No test connection",
          emptyDescription:
            "Create a test connection to start simulating conversations.",
        },
        dialog: {
          title: "New test connection",
          description:
            "The test connection is created already connected and is used only for simulations — no real WhatsApp is involved.",
          nameLabel: "Connection name",
          defaultName: "Test Connection",
          cancel: "Cancel",
          create: "Create",
        },
        client: {
          sectionTitle: "Simulated customer",
          nameLabel: "Customer name",
          numberLabel: "Customer number",
          numberHelper: "Digits only, including country and area code.",
          defaultName: "Test Customer",
          newClientButton: "New customer",
        },
        steps: {
          title: "How it works",
          step1: "Pick (or create) a test connection.",
          step2: "Send a message as the customer using the phone on the right.",
          step3:
            "Watch the ticket arrive in Tickets and reply there — the reply shows up on the phone screen.",
        },
        phone: {
          chip: "TEST MODE",
          online: "online",
          noConnection: "No connection",
          inputPlaceholder: "Type a message",
          emptyTitle: "No messages yet",
          emptyDescription: "Send the first message to start the simulation.",
          emptyNoConnection: "No connection selected",
          emptyNoConnectionHint:
            "Pick or create a test connection to get started.",
        },
        toasts: {
          connectionCreated: "Test connection created successfully!",
          selectConnection: "Select a test connection before sending.",
          invalidNumber: "Enter a valid number for the simulated customer.",
        },
      },
      flydeskDevices: {
        title: "Computers (Flydesk)",
        searchPlaceholder: "Search by name, ID, company...",
        refresh: "Refresh",
        hint: "A computer shows up here after someone signs in to Flydesk on it. Blocking revokes access without deleting the record; deleting frees a licence.",
        empty: "No computers registered yet.",
        emptyHint:
          "Install Flydesk on the computer and sign in with the company login — it shows up here on its own.",
        noResults: "No computers match that search.",
        noDevicesInCompany: "This company hasn't registered any computer yet.",
        online: "Online",
        offline: "Offline",
        blocked: "Blocked",
        unnamed: "Unnamed",
        never: "Never",
        justNow: "just now",
        minutesAgo: "{{m}} min ago",
        hoursAgo: "{{h}} h ago",
        daysAgo: "{{d}} days ago",
        licences: "licences",
        unlimited: "Unlimited",
        deviceCount: "{{n}} computer(s)",
        onlineCount: "{{n}} online",
        copyId: "Click to copy the ID",
        idCopied: "ID copied!",
        blockedHelper: "Blocking prevents this computer from signing in",
        stats: {
          total: "Computers",
          online: "Online now",
          companies: "Companies",
          blocked: "Blocked",
        },
        actions: {
          block: "Block access",
          unblock: "Unblock",
          delete: "Delete computer",
        },
        download: {
          title: "Install Flydesk on this computer",
          description:
            "Download and install it. On first launch, sign in with the same e-mail and password you use here — the computer then shows up in this list automatically.",
          button: "Download for Windows",
        },
        table: {
          name: "Name",
          deviceId: "ID",
          company: "Company",
          user: "Registered by",
          status: "Status",
          lastSeen: "Last seen",
          blocked: "Blocked",
          actions: "Actions",
        },
        confirmDelete: {
          title: "Delete computer",
          message:
            "The computer leaves the list and frees a licence. If someone signs in on it again, it comes back and takes a licence once more.",
        },
        toasts: {
          updated: "Computer updated.",
          deleted: "Computer deleted.",
        },
      },
      companies: {
        details: {
          modulesTitle: "Enabled modules",
          limitsTitle: "Limits and usage",
          devicesTitle: "Flydesk computers",
          users: "Users",
          connections: "Connections",
          devices: "PCs",
          unlimited: "no limit",
          noDevices:
            "No computer registered. Install Flydesk and sign in with this company's login.",
          edit: "Edit company",
        },
        title: "Companies",
        searchPlaceholder: "Search...",
        buttons: { add: "Add company", refresh: "Refresh" },
        stats: {
          total: "Companies",
          active: "Active",
          users: "Users",
        },
        table: {
          name: "Company",
          users: "Users",
          createdAt: "Created at",
          actions: "Actions",
          default: "Default",
          status: "Status",
          connections: "Connections",
          active: "Active",
          inactive: "Inactive",
          cannotDeleteDefault: "The default company cannot be deleted",
          cannotDeactivateDefault: "The default company cannot be deactivated",
          empty: "No companies found",
        },
        modal: {
          addTitle: "New company",
          editTitle: "Edit company",
          name: "Company name",
          adminName: "Admin name",
          adminNameHelper: "If empty, company name is used",
          email: "Login email",
          password: "Password",
          cancel: "Cancel",
          save: "Save",
          adminSection: "Company administrator",
          modulesSection: "Enabled modules",
          moduleWhatsapp: "WhatsApp support",
          moduleWhatsappHelper: "Base module, included for every company",
          module_financeiro: "Finance",
          module_flydesk: "Flydesk (remote access)",
          limitsSection: "Limits (optional)",
          maxDevices: "Flydesk PCs",
          maxDevicesHelper: "How many computers this company may register. Empty = unlimited",
          maxUsersHelp:
            "How many PEOPLE from this company can access the system — each agent with their own e-mail and password.\n\nThe admin created along with the company already counts. E.g.: limit 5 = admin + 4 agents.\n\nOnce the limit is reached, the company cannot create new users. Existing ones keep working.",
          maxConnectionsHelp:
            "How many WhatsApp NUMBERS this company can connect (each QR Code scanned is one connection).\n\nTest Mode connections don't count.\n\nOnce the limit is reached, the company cannot add another number. Already connected ones keep working.",
          maxDevicesHelp:
            "How many COMPUTERS this company can register in Flydesk for remote access.\n\nA PC counts once someone signs in to Flydesk on it for the first time. Once the limit is reached, sign-in is refused with a message.\n\nDeleting a PC on the Remote Access screen frees the slot.",
          maxUsers: "User limit",
          maxConnections: "Connection limit",
          unlimitedHelper: "Empty = unlimited",
          status: "Company active",
          validation: {
            required: "Required",
            tooShort: "Too short",
            tooLong: "Too long",
            invalidEmail: "Invalid email",
            integer: "Use a whole number",
            limitMin: "Must be at least 1",
          },
        },
        toasts: {
          saved: "Company saved successfully.",
          deleted: "Company deleted successfully.",
          activated: "Company activated.",
          deactivated: "Company deactivated.",
        },
        errors: {
          ERR_EMAIL_ALREADY_EXISTS: "A user with this email already exists.",
          ERR_CANNOT_DEACTIVATE_DEFAULT_COMPANY:
            "The default company cannot be deactivated.",
          ERR_USER_LIMIT_REACHED: "The company's user limit has been reached.",
          ERR_CONNECTION_LIMIT_REACHED:
            "The company's connection limit has been reached.",
          ERR_COMPANY_INACTIVE:
            "This company is inactive. Contact the system administrator.",
        },
        confirmationModal: {
          deleteTitle: "Delete company",
          deleteMessage:
            "This deletes ALL company data: users, connections, tickets and contacts. It cannot be undone.",
        },
      },
      ticketsTeam: {
        hint: "Drag a ticket to transfer it between agents or back to the queue.",
        you: "you",
        waitingColumn: "Waiting",
        dropHere: "Drop a ticket here",
        transferredTo: "Ticket transferred to",
        returnedToQueue: "Ticket returned to queue",
        noQueue: "No queue",
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to queue",
        fieldConnectionLabel: "Transfer to connection",
        fieldQueuePlaceholder: "Please select a queue",
        fieldConnectionPlaceholder: "Please select a connection",
        noOptions: "No user found with this name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Queue",
        assignedHeader: "Working on",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No tickets found with this status or search term.",
        connectionTitle: "Connection that is currently being used.",
        assignedTitle: "Agent responsible for this ticket.",
        groupMine: "My tickets",
        groupTeam: "Team",
        buttons: {
          accept: "Accept",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          tickets: "Tickets",
          contacts: "Contacts",
          quickAnswers: "Quick Answers",
          financeiro: "Finance",
          flydesk: "Remote Access",
          queues: "Queues",
          administration: "Administration",
          users: "Users",
          settings: "Settings",
          testMode: "Test Mode",
          superSection: "Platform",
          companies: "Companies",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      queues: {
        title: "Queues",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          actions: "Actions",
        },
        buttons: {
          add: "Add queue",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Queues",
      },
      quickAnswers: {
        title: "Quick Answers",
        table: {
          shortcut: "Shortcut",
          message: "Quick Reply",
          actions: "Actions",
        },
        buttons: {
          add: "Add Quick Reply",
        },
        toasts: {
          deleted: "Quick Reply deleted successfully.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Quick Reply: ",
          deleteMessage: "This action cannot be undone.",
        },
      },
      users: {
        title: "Users",
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          whatsapp: "Default Connection",
          actions: "Actions",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open tickets will be moved to queue.",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
        },
        pix: {
          title: "Company Pix",
          subtitle:
            "Register the key agents send in chat with /pix or the R$ button.",
          key: "Pix key",
          name: "Receiver name",
          nameHelper: "Name shown to the customer when paying",
          city: "City",
          save: "Save Pix",
          saved: "Pix data saved successfully.",
          keyTypes: {
            phone: "Phone",
            random: "Random key",
          },
        },
      },
      pix: {
        buttonTooltip: "Send Pix (/pix)",
        keyTypes: {
          phone: "Phone",
          random: "Random key",
        },
        dialog: {
          title: "Send Pix key",
          copyKey: "Copy Pix key",
          copied: "Pix key copied!",
          send: "Send",
          sent: "Pix key sent!",
          cancel: "Cancel",
          hint: "The customer receives this card on WhatsApp with the copy button.",
          notConfiguredTitle: "Pix not configured yet",
          notConfiguredAdmin:
            "Register the company's Pix key in Settings to send it in chat.",
          notConfiguredUser:
            "Ask the administrator to register the company's Pix key in Settings.",
          goToSettings: "Go to Settings",
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Type a message or press ''/'' to use the registered quick responses",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        extraInfo: "Other information",
      },
      ticketOptionsMenu: {
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete ticket #",
          titleFrom: "from contact ",
          message: "Attention! All ticket's related messages will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
      },
    },
  },
};

export { messages };
